import api from './client';
let entity = 'workouts';


// GET /api/workouts
export const getAll = async () => {
  const { data } = await api.get(`/${entity}`);
  return data;
};

// POST /api/workouts
export const create = async (entry) => {
  const { data } = await api.post(`/${entity}`, entry);
  return data;
};

// GET /api/workouts/:id
export const getById = async (id) => {
  const { data } = await api.get(`/${entity}/${id}`);
  return data;
};

// GET /api/workouts/date/:date  (date as YYYY-MM-DD)
export const getByDate = async (date) => {
  const { data } = await api.get(`/${entity}/date/${date}`);
  return data;
};

// GET /api/workouts/plans/:planId/weeks/:weekNumber
export const getByPlanWeek = async (planId, weekNumber) => {
  const { data } = await api.get(`/${entity}/plans/${planId}/weeks/${weekNumber}`);
  return data;
};

// PUT /api/workouts/:id
export const update = async (id, entry) => {
  const { data } = await api.put(`/${entity}/${id}`, entry);
  return data;
};

// DELETE /api/workouts/:id
export const deleteWorkout = async (id) => {
  const { data } = await api.delete(`/${entity}/${id}`);
  return data;
};

// POST /api/workouts/:id/tasks
export const addTask = async (id, task) => {
  const { data } = await api.post(`/${entity}/${id}/tasks`, task);
  return data;
};

// DELETE /api/workouts/:id/tasks/:taskId
export const removeTask = async (id, taskId) => {
  const { data } = await api.delete(`/${entity}/${id}/tasks/${taskId}`);
  return data;
};

// PUT /api/workouts/:id/tasks/:taskId/completion
export const setTaskCompletion = async (id, taskId, completed) => {
  const { data } = await api.put(`/${entity}/${id}/tasks/${taskId}/completion`, { completed });
  return data;
};

export const downloadGarminWorkouts = async () => {
  const { data } = await api.post(`/${entity}/garmin`);
  return data;
}

export const showGarminWorkouts = async () => {
  const { data } = await api.get(`/${entity}/garmin/show`);
  return data;
}

export const showGarminWorkoutsFit = async () => {
  const { data } = await api.get(`/${entity}/garmin/show/fit`);
  return data;
}

export const showGarminActivity = async (fileName) => {
  const { data } = await api.get(`/${entity}/garmin/activity/${fileName}`);
  return data;
}